var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaypal24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.044 7.342c.04-.258.04-.526.01-.8C18.634 4.02 16.264 3 13.424 3H7.382a.87.87 0 0 0-.86.736L4.012 18.64a.522.522 0 0 0 .516.604h3.76l-.264 1.676a.456.456 0 0 0 .452.528h3.174a.762.762 0 0 0 .754-.644l.03-.162.596-3.782.038-.208a.762.762 0 0 1 .754-.644h.474c3.072 0 5.478-1.248 6.18-4.862.294-1.51.142-2.77-.636-3.656a3.034 3.034 0 0 0-.796-.648z",
    fill: "#179BD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.044 7.342a6.47 6.47 0 0 0-.796-.258 10.1 10.1 0 0 0-1.588-.182H11.8a.762.762 0 0 0-.754.644l-1.08 6.842-.03.2a.87.87 0 0 1 .86-.736h1.79c3.516 0 6.27-1.428 7.074-5.562.024-.122.042-.242.058-.36a4.35 4.35 0 0 0-.674-.588z",
    fill: "#222D65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.046 7.546a.762.762 0 0 1 .754-.644h4.86c.576 0 1.112.038 1.588.182.274.068.53.158.796.258a4.35 4.35 0 0 1 .674.588c.296-1.888-.002-3.174-.984-4.34C17.632 2.286 15.726 1.8 13.424 1.8H7.382a.87.87 0 0 0-.86.736L4.012 17.44a.522.522 0 0 0 .516.604h3.76l.944-5.986 1.814-4.512z",
    fill: "#253B80"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal24);
export default __webpack_public_path__ + "static/media/paypal_24.0d44f060.svg";
export { ForwardRef as ReactComponent };